<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblAddUser</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <div class="card auto p-0">
                <div class="card-content">
                    <div class="card pad15">





                        <div class="row">
                            <div class="col-md-3 ">

                                <div class="input-group">
                                    <input class="form-control" [(ngModel)]="searchString" placeholder="{{ 'lblSearch' | translate }}">
                                    <div class="input-group-append">
                                        <button type="button" aria-label="Center Align" class="btn btn-primary" [disabled]="searchString.length == 0" translate (click)="SearchEmployee(true)">
                                            <em aria-hidden="true" class="fa fa-search"></em>
                                        </button>
                                    </div>
                                </div>



                            </div>
                            <div class="col-auto pl-0">
                                <button class="btn btn-primary" aria-label="Center Align"  translate (click)="ClearEmployee()" [disabled]="searchString.length == 0">lblClear</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body scrollbar  user">

                        <div class="card pad15 mb-3" >

                            <div class="card-header d-flex  justify-content-between">
                                <h4 class="card-title" translate>lblEmployeeList</h4>
                                <div class="font16 fontbold">
                                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                                    totalCount
                                    }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                                </div>
                            </div>
                                <div class="table-responsive max-h254"
                                infinite-scroll
                                [infiniteScrollDistance]="scrollDistance"
                                [infiniteScrollThrottle]="throttle"
                                [scrollWindow]="false"
                                (scrolled)="onScrollDown($event)">
                                <table class="tablest1">
                                    <thead>
                                        <tr>
                                            <th style="width: 10%" scope="col">#</th>
                                            <th style="width: 20%" scope="col"><span translate>lblName</span></th>
                                            <th style="width: 15%" scope="col" translate>lblEmail</th>
                                            <th style="width: 15%" scope="col" translate>lblMobile</th>
                                            <th style="width: 15%" scope="col" *ngIf="!areCodesHidden" translate>lblDealershipsId</th>
                                            <th style="width: 15%" scope="col" *ngIf="!areCodesHidden" translate>lblFunctionCode</th>
                                            <th style="width: 20%" scope="col" translate>lblADEmail</th>
                                            <th style="width: 20%" scope="col" translate>lblRole</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="employeeList?.length>0; else load_else">
                                            <tr *ngFor="let user of employeeList; let i=index">
                                                <td>
                                                    <input type="radio" name="list" [ngStyle]="{'background-color': user.isAddedAsUser ? '#d3d3d3' :  null }" [disabled]="user.isAddedAsUser" class="radio-custom" value="{{user.id}}" (change)="OpenAddUserForm(mymodal,user)" />
                                                </td>
                                                <td>
                                                    {{user.firstName}} {{user.lastName}}
                                                </td>
                                                <td>
                                                    {{user.email}}
                                                </td>
                                                <td>
                                                    {{user.phoneNo}}
                                                </td>
                                                <td *ngIf="!areCodesHidden">
                                                    <span *ngIf="user.locationCode">
                                                    {{user.locationCode}} - {{user.locationName}}
                                                </span>
                                                  </td>
                                                  <td *ngIf="!areCodesHidden">
                                                    <span *ngIf="user.functionCode">{{user.functionCode}} - {{user.functionCodeDescription}}</span>

                                                  </td>
                                                <td>
                                                    {{user.adEmail}}
                                                </td>
                                                <td>
                                                    {{user.groupRoleName}}
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_else>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <ng-template #mymodal let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title" translate>lblUserDetail</h4>
                                <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <div class="">
                            <form [formGroup]="addUserForm" (ngSubmit)="onSubmit()" *ngIf="addUser && employeeList?.length>0">
                                <div class="card mb15 pad15 border">
                                <div class="form-row">
                                    <div class="col-md-4 af-form-group">
                                        <label for="role"><span translate>lblRole</span><span class="text-danger"> * </span>
                                </label>
                                        <div class="lbl-info">
                                            <select formControlName="roleId" (change)="onRoleChange($event.target.value)" [ngClass]="{'is-invalid': (cpf.roleId.touched || cpf.roleId.dirty) && cpf.roleId.errors}" class="custom-select custom-select mb-2">
                                    <option disabled value="" translate>lblSelectRole</option>
                                    <option *ngFor="let role of roleList" [ngValue]="role.id">
                                      {{role.roleName}}</option>
                                  </select>
                                            <div *ngIf="(cpf.roleId.touched || cpf.roleId.dirty) && cpf.roleId.errors">
                                                <div *ngIf="cpf.roleId.errors.required || cpf.roleId.errors.min || cpf.roleId===-1" class="help-block mt-1 text-danger" translate>
                                                    lblRoleRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-4 af-form-group ctm-dropdwn">
                                        <label for="dealer"><span translate>lblDealer</span><span class="text-danger"> * </span>
                                </label>
                                        <div class="lbl-info" *ngIf="receptionRole">
                                            <select formControlName="dealerId"  class="custom-select custom-select mb-2">
                                                <option disabled value="" translate>lblSelectDealer</option>
                                                <option *ngFor="let dealer of dealerListSingleSelection"  [value]="dealer.value">
                                                {{dealer.text}}</option>
                                            </select>
                                            <div *ngIf="(cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors">
                                                <div *ngIf="cpf.dealerId.errors.required || cpf.dealerId.errors.min || cpf.dealerId===-1" class="help-block mt-1 text-danger" translate>
                                                    lblDealerRequired
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!receptionRole">
                                            <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dealerList"
                                             placeholder="{{ 'lblSelectDealer'| translate}}" formControlName="dealerId"
                                             (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
                                            </ng-multiselect-dropdown>
                                            <div *ngIf="(cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors" >
                                                <div *ngIf="cpf.dealerId.errors.required || cpf.dealerId.errors.min || cpf.dealerId===-1" class="help-block mt-1 text-danger" translate>
                                                    lblDealerRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 af-form-group">
                                        <label for="name"><span translate>lblName</span><span class="text-danger"> * </span>
                                </label>
                                        <div class="lbl-info">
                                            <input formControlName="name" class="form-control mb-2" maxlength="30" [ngClass]="{'is-invalid': (cpf.name.touched || cpf.name.dirty) && cpf.name.errors}" placeholder="{{ 'lblEnterName' | translate }}">
                                            <div *ngIf="(cpf.name.touched || cpf.name.dirty) && cpf.name.errors">
                                                <div *ngIf="cpf.name.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblNameRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 af-form-group">
                                        <label for="mobile"><span translate>lblMobile</span><span class="text-danger"> * </span>
                                </label>
                                        <div class="lbl-info">
                                            <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" [cssClass]="{'form-control': true, 'is-invalid': (cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors}"
                                            [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false" (keyup)="onMobileNoChange()"
                                            [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                                            [customPlaceholder]="'lblEnterMobile' | translate"
                                            (countryChange)="onCountryChange($event)"
                                            ></ngx-intl-tel-input>
                                            <div *ngIf="(cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors">
                                                <div *ngIf="cpf.mobile.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblMobileRequired
                                                </div>
                                                <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                                                    lblEnterValidMobile
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 af-form-group">
                                        <label for="landline"><span translate>lblLandline</span>
                                </label>
                                        <div class="lbl-info">
                                            <input formControlName="landline" maxlength="15" (keypress)="isDigit($event)" [ngClass]="{'is-invalid': (cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors}" class="form-control mb-2" placeholder="{{ 'lblEnterLandline' | translate }}">
                                            <div *ngIf="(cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors">
                                                <div *ngIf="cpf.landline.errors.pattern" class="help-block mt-1 text-danger" translate>
                                                    lblEnterValidLandline
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 af-form-group">
                                        <label for="ADUSerId"><span translate>lblADGUID</span> <span class="text-danger"> * </span>
                                        </label>
                                        <div class="lbl-info">
                                            <input formControlName="adUserId" id="ADUSerId" class="form-control mb-2"
                                                [ngClass]="{'is-invalid': (cpf.adUserId.touched || cpf.adUserId.dirty) && cpf.adUserId.errors}"
                                                placeholder="{{ 'lblEnterADGUID' | translate }}" maxlength="36">
                                            <div *ngIf="(cpf.adUserId.touched || cpf.adUserId.dirty) && cpf.adUserId.errors">
                                                <div *ngIf="cpf.adUserId.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblADGUIDRequire
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 af-form-group">
                                        <label for="ADUSerId"><span translate>lblADEmail</span> <span class="text-danger"> * </span>
                                        </label>
                                        <div class="lbl-info">
                                            <input formControlName="adEmail" id="adEmail" class="form-control mb-2"
                                                [ngClass]="{'is-invalid': (cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors}"
                                                placeholder="{{ 'lblEnterADEmail' | translate }}" maxlength="50">
                                            <div *ngIf="(cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors">
                                                <div *ngIf="cpf.adEmail.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblADEmailRequired
                                                </div>
                                                <div *ngIf="cpf.adEmail.errors.pattern" class="help-block mt-1 text-danger" translate>
                                                    lblEnterValidADEmail
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 af-form-group">
                                        <label>&nbsp;</label>
                                        <div class='lbl-info'>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                                                <label class="custom-control-label" for="isActive" translate>lblActive</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                        </div>
                    </form>
                </div>

            </div>
            <div class="modal-footer">
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="submit" class="btn btn-primary mr-sm-2" [disabled]="addUserForm.invalid" (click)="onSubmit()" translate
                        aria-label="Center Align"><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd</button>
                    <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                        translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
                </div>
            </div>
        </ng-template>


                    </div>
                    <div class="p-3 bg-light pp-footer-top-brdr">
                        <div class="d-flex flex-sm-row flex-column justify-content-end">
                            <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
